import { formatDateTimeReadable, OnboardingDetailsRole } from '@nemuru-eng/js-api-client';

import { StoredBorrowerOnboardingDetails } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/Loan/Loan/_shared/types';

export class OnboardingDetailsOption {
  public readonly dateOfCart: string;
  public readonly roleTypeIcon: string;
  public readonly borrowerName: string;
  public readonly borrowerEmail: string;

  public constructor(public readonly onboardingDetails: StoredBorrowerOnboardingDetails) {
    this.dateOfCart = formatDateTimeReadable(onboardingDetails.createdAt);
    this.roleTypeIcon = onboardingDetails.role === OnboardingDetailsRole.BORROWER ? 'person' : 'group';
    this.borrowerName = `${onboardingDetails.userDetails.documentId.name.first} ${onboardingDetails.userDetails.documentId.name.last}`;
    this.borrowerEmail = onboardingDetails.email;
  }
}
